module.exports = "https://cdn.realtymogul.com/static/media/icon_expand.1731b1a1.svg";